var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgDay3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 650 406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffaa3c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fleck_Berlin_4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M437.5,350.9c.61,99.16-344.12,39.85-381.58-9.22S-9.87,134.82,4.93,96.62,44.48,13.59,114,2.16s123.46,34.7,216.81,29.5C410.92,27.2,465.52,60,475.69,102.48c14.75,61.66,26.84,83.33,20,125.9C490.47,261,436.83,242.51,437.5,350.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M582.77,252.08c-12.77-2.08-42.91.67-52.71,11.26-13.95,15.09-12.45,36.7-13.19,56.27A24.15,24.15,0,0,0,521,333.28a27.85,27.85,0,0,0,8.72,8.7c22.63,14.59,51.84,23.49,78.67,16.66s46.42-32.83,39.61-57c-11.26-39.94-40.33-44.51-65.18-49.53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDay3);
export default __webpack_public_path__ + "static/media/bg_day_3.440f31708ae9f1eeee4e3a8b7ab85473.svg";
export { ForwardRef as ReactComponent };